import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import CustomPagination from "../../components/pagination";
import { useNavigate } from "react-router-dom";
import DemandProfileModal from "../../components/demand-profile-modal";
import { demandProfileService } from "../../utils/services/demandProfileService";
import DemandProfileList from "../../components/demand-profile-list";
import buildQuery from "../../utils/query-builder";

const DemandProfile = () => {
  const [selectedData, setSelectedData] = useState(null);
  const [demandProfileList, setDemandProfileList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [openDemandProfileModal, setOpenDemandProfileModal] = useState(false);
  const fetchDemandProfile = async () => {
    setLoading(true);
    try {
      const response = await demandProfileService.fetch(
        null,
        buildQuery({ limit: rowsPerPage, skip: page * rowsPerPage }),
      );
      setDemandProfileList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDemandProfile();
  }, [page, rowsPerPage]);

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Profiles"}
        title={"+ Profile"}
        onClickAddButton={() => setOpenDemandProfileModal(true)}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchDemandProfile()}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <DemandProfileList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchDemandProfile}
            onEditData={(e) => {
              setSelectedData(e);
              setOpenDemandProfileModal(true);
            }}
            data={demandProfileList}
            viewMode={viewMode}
            selectedDemandProfile={selectedData}
            setSelectedDemandProfile={setSelectedData}
          />
        )}
      </DashboardContainer>
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
      <DemandProfileModal
        open={openDemandProfileModal}
        onClose={() => {
          setOpenDemandProfileModal(false);
          setSelectedData(null);
        }}
        editData={selectedData}
        onSuccess={() => {
          fetchDemandProfile();
          setSelectedData(null);
        }}
      />
    </>
  );
};

export default DemandProfile;
